<div class="lock-tooltip">
    <lib-app-icon
        icon="lock_icon"
        [size]="getIconSize()"
        [matTooltip]="getLockedTooltipMessage()"
        matTooltipPosition="below"
        matTooltipClass="cal-tooltip"
    />
</div>
